import { ArrowRight } from "lucide-react";
import "../../styles/home.css";
import Navbar from "../common/Navbar";
import homehero from "../../assets/images/homepage/homeheropage/homehero.jpg";

const HomePageHero = () => {
  const scrollToWhatWeDo = () =>
    document.querySelector("#what-we-do")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section className="tr-hero">
      <Navbar transparent />
      <div className="tr-hero-bg" style={{ backgroundImage: `url(${homehero})` }} />

      <div className="tr-hero-content">
        <span className="tr-hero-eyebrow">Ideas × People × Technology × Culture</span>
        <h1 className="tr-hero-heading">
          We turn ideas <br />
          into impact<span>.</span>
        </h1>
        <p className="tr-hero-sub">
          From brand experiences and content to talent, technology and strategic
          partnerships, we bring the right capabilities together to help brands
          connect with their audiences.
        </p>
        <button type="button" className="tr-hero-btn" onClick={scrollToWhatWeDo}>
          Explore What We Do <ArrowRight size={16} />
        </button>
      </div>
    </section>
  );
};

export default HomePageHero;
